import React from 'react';
import ArrowDropDownIcon from '@mui/icons-material//ArrowDropDown';
import { Checkbox, SortDirection, TableRow } from '@mui/material';
import { CHECKBOX_ITEM_ID } from 'common/constants/documents';
import ExtraActionsMenu from 'components/ExtraActionsMenu';
import theme from 'theme';
import {
  StyledTableCell,
  StyledTableHead,
  StyledTableHeadLabel,
  StyledTableSortLabel,
  StyledVisuallyHidden,
} from './EnhancedTableHead.styles';
import { EnhancedTableHeadColumn, EnhancedTableHeadProps, Order } from './types';

const EnhancedTableHead = ({
  sortDirection,
  orderBy,
  onRequestSort,
  columns,
  files,
  selectedFiles,
  setSelectedFiles,
}: EnhancedTableHeadProps) => {
  const createSortHandler = (property: string) => (event: React.MouseEvent<unknown>) => {
    onRequestSort(event, property);
  };

  const orderHandler = (sortArg: string, sortDefault: SortDirection) => {
    if (orderBy === sortArg) {
      return sortDirection;
    }
    return sortDefault;
  };

  const isActive = (headCell: EnhancedTableHeadColumn) => orderBy === headCell.id;

  const getSortIconStyle = (headCell: EnhancedTableHeadColumn) => ({
    icon: {
      width: '10%',
      ...(isActive(headCell) && {
        color: `${theme.palette.primary.dark} !important`,
        opacity: 1,
      }),
      ...(!isActive(headCell) && {
        opacity: 0.2,
      }),
    },
  });

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      setSelectedFiles?.(files ?? []);
      return;
    }
    setSelectedFiles?.([]);
  };

  return (
    <StyledTableHead>
      <TableRow>
        {columns.map(headCell => (
          <StyledTableCell
            key={headCell.id}
            align={headCell.align || 'left'}
            sortDirection={orderHandler(headCell.id, false)}>
            {headCell.id === CHECKBOX_ITEM_ID && (
              <Checkbox
                checked={Boolean(files?.length && files?.length > 0) && selectedFiles?.length === files?.length}
                slotProps={{ input: { 'aria-label': 'select all documents' } }}
                onChange={handleSelectAllClick}
              />
            )}
            {headCell.id !== CHECKBOX_ITEM_ID && headCell.isSortable && (
              <StyledTableSortLabel
                active={isActive(headCell)}
                direction={orderHandler(headCell.id, 'asc') as Order}
                onClick={createSortHandler(headCell.id)}
                slotProps={getSortIconStyle(headCell)}
                IconComponent={ArrowDropDownIcon}>
                <StyledTableHeadLabel>{headCell.label}</StyledTableHeadLabel>
                {isActive(headCell) && <StyledVisuallyHidden>{`sorted ${sortDirection}ending`}</StyledVisuallyHidden>}
              </StyledTableSortLabel>
            )}
            {headCell.id !== CHECKBOX_ITEM_ID && !headCell.isSortable && (
              <StyledTableHeadLabel>{headCell.label}</StyledTableHeadLabel>
            )}
            {headCell.component === 'actions' && (
              <ExtraActionsMenu options={headCell.options} dotsColor={theme.palette.grey[500]} />
            )}
          </StyledTableCell>
        ))}
      </TableRow>
    </StyledTableHead>
  );
};

export default EnhancedTableHead;
